<template>
  <div style="cursor: pointer" class="delete-icon" @click="onIconClicked">
    <div class="icon-container">
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg> -->
      Xóa
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  // props: {
  //   params: {
  //     type: Object,
  //     default: null
  //   }
  // },
  methods: {
    onIconClicked() {
      if (this.params) {
        console.log(this.params)
        this.params.context.componentParent.onDeleteIconClicked(this.params)
      }
    }
  }
})
</script>
<style lang="scss">
.delete-icon {
  color: rgb(241, 43, 55);
  &:hover {
    opacity: 0.6;
  }
  .icon-container {
    // background-color: green;
    background-color: rgb(255, 223, 225);
    border: 1px solid rgb(241, 43, 55);
    padding: 1px 10px;
    border-radius: 5px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
